import React from "react";
import { Container, Navbar, Row, Col, CloseButton } from "react-bootstrap";
import { useHistory } from "react-router";
import "./UnplannedMedicalVisits.css";
import "../DrillDownPage.css";
import { useSelector } from "react-redux";

const UnplannedMedicalVisitsHeader = () => {
  const history = useHistory();
  const unplannedVisitData = useSelector((state) => state?.dashboard);
  const interval = useSelector((state) => state?.globalFilters?.interval);

  return (
    <Navbar className="header-UMV drilldown-header">
      <Container fluid className="px-0">
        <Row className="drilldown-header-row w-100 align-items-center g-2">
          <Col xs={12} sm={7} md={6} lg={5}>
            <div className="drilldown-header-brand">
              <div className="drilldown-header-brand-icon">
                <img src="/images/dashboard/umv.png" alt="Unplanned Medical Visits" />
              </div>
              <div className="drilldown-header-title-block">
                <span className="header-text">
                  Unplanned Medical
                  <br />
                  Visits
                </span>
              </div>
              <div className="drilldown-header-count">
                <span className="event-count">
                  {unplannedVisitData?.unplannedMedicalVisit?.counts?.total}
                </span>
                <span className="count-lable">Admission/visits</span>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={4} className="drilldown-header-stats-col">
            <div className="drilldown-header-stats">
              <span className="drilldown-header-stat-item">
                <strong>{unplannedVisitData?.unplannedMedicalVisit?.counts?.emergencyRoom}</strong>
                Emergency Room
              </span>
              <span className="drilldown-header-stat-item">
                <strong>{unplannedVisitData?.unplannedMedicalVisit?.counts?.hospital}</strong>
                Hospitalization
              </span>
              <span className="drilldown-header-stat-item">
                <strong>{unplannedVisitData?.unplannedMedicalVisit?.counts?.doctorsOffice}</strong>
                Doctor Visits
              </span>
            </div>
          </Col>
          <Col xs={12} sm={5} md={6} lg={3}>
            <div className="drilldown-header-actions">
              <h5 className="event-days">{interval}</h5>
              <CloseButton
                style={{ opacity: "1" }}
                variant="white"
                aria-label="Hide"
                onClick={() => history.goBack()}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};

export default UnplannedMedicalVisitsHeader;
